import { render, staticRenderFns } from "./RequestWorkTypeListElement.vue?vue&type=template&id=579d2037&"
import script from "./RequestWorkTypeListElement.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypeListElement.vue?vue&type=script&lang=js&"
import style0 from "./RequestWorkTypeListElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip,QIcon} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QIcon}, component.options.components || {})
